import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { SharedService } from '../../shared.service';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {
  term: string = '';
  searched_string = '';
  subscription: any;
  emptyData!: boolean;
  results: any = {
    partners: [],
    patients: [],
    doctors: [],
    contracts: [],
    payments: [],
    ar: [],
    proposal: [],
    pa_leads: [],
    training:[],
    settled_accounts:[]
  };
  show: any = {
    doctor: true,
    contract: true,
    patient: true,
    partner: false,
    payments: false,
    ar: false,
    proposal: true,
    pa_leads: false,
    training:true,
    settled_accounts: true,
    assignments: true,
    callback_assignments: true
  };
    public totalRowsOfEach:any={};

  constructor(
    private route: ActivatedRoute,
    public location: Location,
    public router: Router,
    public _shared: SharedService,
    private _api: ApiService
  ) {
  }

  ngOnInit() {
    this.subscription = this.route.queryParams.subscribe((data: any) => {
      this.searchData(data.search);
      this.handleSearch();
    });
  }

  searchData(data: any) {
    this.term = data;
    if (!(/[a-zA-Z]/.test(this.term + '')) && (/[0-9]/.test(this.term + ''))) {
        const number = (this.term + '').replace(/[^\d]/g, '');
        this.term = number + '';
    }
    console.log(this.term);
    // const isPhoneNumber = patterns.some(pattern => pattern.test((this.term + '').trim()));
    // if (isPhoneNumber) {
    //   console.log(isPhoneNumber)
    //   const digits = (this.term + '').match(/\d+/g);
    //   this.term = digits ? digits.join('') : '';
    // }
  }

  search(){
    this.searchData(this.term);
    this.router.navigate(['/app/search'], {queryParams: {search: this.term}, queryParamsHandling: 'merge'})
  }

  handleSearch() {
    if (!this.term) {
      this._shared.customPopups('Enter a value to search', 2);
      return;
    }
    let data = {
      search_string: this.term
    };
    this._api.api(data, 'dashboard/search', 'get')
      .subscribe((res: any) => {
        console.log(res);
        this.results.partners = res.partner_list;
        this.results.doctors = res.doctor_list;
        this.results.patients = res.patient_list;
        this.results.contracts = res.pf_payments;
        this.results.payments = res.payments_list;
        this.results.ar = res.ar_list;
        this.results.proposal = res.proposal_list;
        this.results.pa_leads = res.pa_leads;
        this.results.training = res.training_list;
        this.results.settled_accounts = res.settled_accounts;
        this.results.assignments = res.assignments;
        this.results.callback_assignments = res.callback_assignments;
        this.totalRowsOfEach=res.totalRowsOfEach;
        if (
          this.results &&
          (!this.results.partners || !this.results.partners.length) &&
          (!this.results.doctors || !this.results.doctors.length) &&
          (!this.results.patients || !this.results.patients.length) &&
          (!this.results.contracts || !this.results.contracts.length) &&
          (!this.results.payments || !this.results.payments.length) &&
          (!this.results.ar || !this.results.ar.length) &&
          (!this.results.proposal || !this.results.proposal.length) &&
          (!this.results.pa_leads || !this.results.pa_leads.length) &&
          (!this.results.training || !this.results.training.length) &&
          (!this.results.settled_accounts || !this.results.settled_accounts.length) &&
          (!this.results.assignments || !this.results.assignments.length) &&
          (!this.results.callback_assignments || !this.results.callback_assignments.length)
        ) {
          this.emptyData = true;
          this._shared.customPopups('No results found!', 1);
        } else {
          this.searched_string = this.term;
          this.emptyData = false;
        }
      });
  }
  viewPartner(partner_id: any) {
    // MainService.customSetItem("partnerList", partner_id);
    this.router.navigate(['app', 'partners', 'profile', partner_id]);
  }

   viewAllDetails(search_type:any){
    this.router.navigate(['/app/details-search'], {queryParams: {search: this.term , search_type:search_type}, queryParamsHandling: 'merge'})
  }


  ngOnDestroy(): void {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  storeInfoAction(hash_value: any, key: any, index: any){
    this._shared.storeInfoAction(hash_value, 'global search').subscribe(data => {
      this.results.doctors[index][key] = data?.value;
    });
  }

}
